import React from "react";
import Logo from "../../assets/images/logo-2.png";
import "./styles/landing.css"; 

const About = (props) => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row align-items-center gx-5"> 
          
          {/* Kiri: Kolom Logo */}
          <div className="col-12 col-lg-5 mb-5 mb-lg-0">
            <div className="about-logo-wrapper">
              <img 
                src={Logo} 
                className="img-fluid pivot-animation" 
                alt="Logo BPPMHKP" 
              />
            </div>
          </div>

          {/* Kanan: Kolom Konten */}
          <div className="col-12 col-lg-7">
            <div className="about-content">
              <div className="about-header">
                <h2>TENTANG BPPMHKP</h2>
                <div className="accent-line"></div>
              </div>
              
              <p className="about-description"> 
                BPPMHKP adalah singkatan dari <strong>Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan</strong>. 
                Badan ini merupakan otoritas kompeten di bawah Kementerian Kelautan dan Perikanan (KKP) yang bertugas 
                untuk menjamin mutu hasil kelautan dan perikanan melalui pengendalian dan pengawasan yang ketat, 
                mulai dari hulu hingga hilir.
              </p>
              
              <div className="row g-4 mt-2"> 
                {/* Card Kelompok 1 */}
                <div className="col-md-6">
                  <div className="service-premium-card"> 
                    <div className="card-badge postharvest">Pascapanen</div>
                    <h3>Layanan Sertifikasi Produk Perikanan Pascapanen</h3>
                    <ul className="premium-list">
                      {props.data?.Why ? (
                        props.data.Why.map((d, i) => (
                          <li key={`why-${i}`}>
                            <span className="list-icon">✓</span>
                            <span className="list-text">{d}</span>
                          </li>
                        ))
                      ) : (
                        <li className="text-muted">Loading...</li>
                      )}
                    </ul>
                  </div>
                </div>

                {/* Card Kelompok 2 */}
                <div className="col-md-6">
                  <div className="service-premium-card"> 
                    <div className="card-badge primary-sector">Primer</div>
                    <h3>Layanan Sertifikasi Produk Perikanan Primer</h3>
                    <ul className="premium-list">
                      {props.data?.Why2 ? (
                        props.data.Why2.map((d, i) => (
                          <li key={`why2-${i}`}>
                            <span className="list-icon">✓</span>
                            <span className="list-text">{d}</span>
                          </li>
                        ))
                      ) : (
                        <li className="text-muted">Loading...</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;